import { createFileRoute } from '@tanstack/react-router';

import { ZonesPage } from '@/features/siteplan/zones-page';

export const Route = createFileRoute('/_app/projects/$projectId/plan/zones')({
  component: PageRoute,
});

function PageRoute() {
  const { projectId } = Route.useParams();
  return <ZonesPage projectId={projectId} />;
}
